import { render } from "./PDFViewerControlBar.vue?vue&type=template&id=fa984594"
import script from "./PDFViewerControlBar.vue?vue&type=script&lang=js"
export * from "./PDFViewerControlBar.vue?vue&type=script&lang=js"

import "./PDFViewerControlBar.vue?vue&type=style&index=0&id=fa984594&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__